import { handlers } from '_helpers';
import crFetch from '_helpers/fetch';

const { handleResponseAsync } = handlers;

async function getLicenseJournals(accountID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/licenseJournals/${accountID}`
      }))
  );
}

const licenseJournalService = {
  getLicenseJournals
};

export default licenseJournalService;
